module.exports = __webpack_public_path__ + "img/mirror20.cfa83147.jpg";